<template>
  <nav class="navbar sticky-top navbar-light bg-white">
    <div class="container-fluid d-flex justify-content-between align-items-center">

      <!-- Menú (móvil) + Logo -->
      <div class="d-flex align-items-center">
        <button type="button" class="ew-menu-toggle d-lg-none" aria-label="Abrir menú"
          @click="$root.$emit('ew-toggle-sidebar')">
          <i class="bi bi-list"></i>
        </button>
        <router-link to="/">
          <img src="@/assets/images/sack/logo.png" height="80" alt="Logo" class="ew-footer-logo" />
        </router-link>
      </div>

      <!-- Usuario y menú desplegable -->
      <div class="d-flex align-items-center position-relative">
        <button class="btn btn-light d-flex align-items-center dropdown-toggle"
          @click.stop="dropdownOpen = !dropdownOpen">
          <span class="d-none d-md-block mr-2">{{ user.email }}</span>
          <i class="bi bi-person-circle"></i>
        </button>

        <!-- Dropdown -->
        <div v-if="dropdownOpen" class="dropdown-menu dropdown-menu-end show mt-2"
          style="position: absolute; right: 0; left: auto; top: 100%;">
          <router-link to="/account" class="dropdown-item d-flex align-items-center" @click="dropdownOpen = false"
            v-if="!hasRole(['user', 'admin'])">
            <i class="bi bi-person-circle me-2 text-primary"></i> Mi Cuenta
          </router-link>

          <router-link to="/company" class="dropdown-item d-flex align-items-center" @click="dropdownOpen = false"
            v-if="!hasRole(['user', 'admin'])">
            <i class="bi bi-building me-2 text-primary"></i> Compañía
          </router-link>

          <div class="dropdown-divider" v-if="!hasRole(['user', 'admin'])"></div>

          <button class="dropdown-item text-danger d-flex align-items-center" @click="logout" v-b-tooltip.hover.top="'Cerrar sesión y volver a la página de inicio de sesión'">
            <i class="bi bi-box-arrow-right me-2"></i> Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { roleMixin } from '@/mixins/roleMixin';

export default {
  name: "NavBar",
  mixins: [roleMixin],
  props: { name: String },
  data() {
    return {
      dropdownOpen: false,
    };
  },
  created() {
    this.getUser();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  computed: { ...mapGetters(["user"]) },
  methods: {
    logout() {
      localStorage.clear();
      this.setUser(null);
      this.$router.push("/signin");
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
    ...mapActions(["getUser"]),
    ...mapMutations(["setUser"]),
  },
};
</script>

<style>
.mr-2 {
  margin-right: 0.5rem;
}

.dropdown-menu {
  min-width: 180px;
  border-radius: 10px;
}

.dropdown-item i {
  font-size: 1rem;
}

.ew-menu-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-right: 8px;
  padding: 0;
  background: #f1f3f9;
  border: none;
  border-radius: 10px !important;
  color: #031d7d;
  font-size: 1.4rem;
}

.ew-menu-toggle:hover {
  background: #e4e8f3;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Navbar.vue